module.exports = __webpack_public_path__ + "img/10-twoImg.4aa5532c.png";